import { FC } from "react";
import { useTranslation } from "react-i18next";

import { UploadFile } from "@ryde/controls";
import { errors, Log, SUPPORTED_UPLOAD_FILE_ACCEPT } from "@ryde/shared";

import { DrawerFormWrapperStyled } from "../drawer";
import { GenericUploadCreateEntities } from "./generic-upload-create-entities";
import {
  GenericUploadFileWrapper,
  GenericUploadPrepareErrorStyled,
} from "./generic-upload.styled";
import { isSupportedGenericUploadFile } from "./helpers";
import { useGenericUploadForm } from "./hooks";

interface IGenericUploadFormProps {
  prepareError?: string;
}

export const GenericUploadForm: FC<IGenericUploadFormProps> = ({
  prepareError,
}) => {
  const { t } = useTranslation();
  const { file, onFileChange, onFileClear } = useGenericUploadForm();

  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    const fileFromEvent = event.target.files?.[0];

    if (!fileFromEvent) {
      Log.debug("No file selected");
      return;
    }

    if (!isSupportedGenericUploadFile(fileFromEvent)) {
      Log.warnAndToast(t(errors.common.invalidFileType));
      return;
    }

    onFileChange(fileFromEvent);
  };

  return (
    <DrawerFormWrapperStyled>
      <GenericUploadFileWrapper>
        <UploadFile
          accept={SUPPORTED_UPLOAD_FILE_ACCEPT}
          onChange={handleChange}
          onClear={onFileClear}
          file={file}
        />
      </GenericUploadFileWrapper>
      <GenericUploadCreateEntities />
      {!!prepareError && (
        <GenericUploadPrepareErrorStyled>
          <div className="error-text">{prepareError}</div>
        </GenericUploadPrepareErrorStyled>
      )}
    </DrawerFormWrapperStyled>
  );
};
